const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLicenseManageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 6817"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 157502",
    style: {
      fill: "none"
    },
    d: "M0 0h24v25H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 6142",
    d: "m73.78-855.676-1.713-2.886-3.252-.713.317-3.348-2.2-2.521 2.2-2.521-.317-3.348 3.252-.713 1.713-2.886 3.06 1.3 3.06-1.3 1.712 2.886 3.252.713-.317 3.348 2.2 2.521-2.2 2.521.317 3.348-3.252.713-1.712 2.886-3.06-1.3zm.613-1.838 2.447-1.037 2.477 1.037 1.362-2.3 2.639-.605-.24-2.706 1.775-2.015-1.775-2.045.24-2.706-2.639-.576-1.391-2.3-2.447 1.037-2.477-1.037L73-870.469l-2.639.576.24 2.706-1.775 2.045 1.775 2.015-.24 2.735 2.639.576zm2.447-7.629zm-1.008 3.074 5.09-5.09-1.011-1.041-4.079 4.079-2.063-2.034-1.011 1.011z",
    transform: "translate(-64.84 877.643)",
    style: {
      fill: "#030814"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseManageIcon);
export default __webpack_public_path__ + "static/media/license_manage_icon.db97aa69527026d13249f10fc77ce3fc.svg";
export { ForwardRef as ReactComponent };